import { Grid, MenuItem } from '@material-ui/core';
import { Skeleton } from '@material-ui/lab';
import {
  getDegree,
  getFormationsMap,
  getTrainingDomains,
  getTrainingType,
} from '@webapps/business';
import {
  Button,
  Pagination,
  PaginationNumbers,
  TextField,
  useAuth,
  useQuery,
} from '@webapps/reactjs-tech-components';
import { useStyles } from '@webapps/styles';
import Modal from 'components/Modal';
import { useEffect, useState } from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import { useLocation } from 'react-router-dom';
import {
  Search,
} from '@material-ui/icons';

import CardFormation from './CardFormation';
import CreateFormation from './CreateFormation';
import Information from 'components/Icons/Information';
import Nodata from 'components/NoData';
import theme from '../theme';

const Formations = ({ handleFormationsLength }) => {
  const {
    classes,
    css,
    global,
    cx,
    theme: { spacing },
  } = useStyles(styles);
  const intl = useIntl();
  const location = useLocation();
  const { idUser } = useAuth();
  const [degree, setDegree] = useState('');
  const [openCreateFormation, setOpenCreateFormation] = useState(false);
  const [keyword, setKeyword] = useState(location?.state?.trainingLabel || '');

  const {
    images: { TrainingsWithSheets }
  } = theme

  const handleOpenCreateFormation = () => {
    setOpenCreateFormation(true);
  };

  const handleCloseCreateFormation = () => {
    setOpenCreateFormation(false);
  };

  const [page, setPage] = useState(1);
  const [size, setSize] = useState(window.innerWidth > 1770 ? 8 : window.innerWidth > 1024 ? 6 : 4);
  const [stepModal, setStepModal] = useState(1);

  useEffect(() => {
    if (location.state?.openCreateFormation) {
      handleOpenCreateFormation();
      location.state.openCreateFormation = false;
    }
  }, [location]);

  const [trainingType, setTrainingType] = useState('');
  const [trainingDomain, setTrainingDomains] = useState('');

  const {
    status: load,
    data: { content: formations = [], totalElements } = {},
    refetch,
    isFetching,
    isLoading: isLoadingFormations,
  } = useQuery(getFormationsMap, {
    key: [
      'formationss',
      page + idUser + keyword + trainingDomain + trainingType + degree,
    ],
    variables: {
      keyword,
      degrees: degree,
      trainingTypes: trainingType,
      domains: trainingDomain,
      schools: idUser,
      page: page - 1,
      size,
    },
    keepPreviousData: true,
    staleTime: 5000,
  });

  const { data: degrees = [] } = useQuery(getDegree, {
    key: 'degreeMap',
  });

  const searchDegree = (e) => {
    if (e.target.value) {
      // eslint-disable-next-line no-unused-expressions
      e.target.value === 'all' ? setDegree('') : setDegree(e.target.value);
      setPage(1);
    }
  };

  const {
    data: { content: trainingDomains = [] } = {},
    isLoading: trainingDomainsLoading,
  } = useQuery(getTrainingDomains, {
    key: 'trainingDomainsMap',
  });

  const searchTrainingDomains = (e) => {
    if (e.target.value) {
      // eslint-disable-next-line no-unused-expressions
      e.target.value === 'all'
        ? setTrainingDomains('')
        : setTrainingDomains(e.target.value);
      setPage(1);
    }
  };

  const handlePaginationChange = (newPage) => {
    setPage(newPage);
  };

  const { data: trainingTypes = [] } = useQuery(getTrainingType, {
    key: 'trainingTypeMap',
  });

  const searchTrainingType = (e) => {
    if (e.target.value) {
      // eslint-disable-next-line no-unused-expressions
      e.target.value === 'all'
        ? setTrainingType('')
        : setTrainingType(e.target.value);
      setPage(1);
    }
  };

  const searchFormation = (e) => {
    // if (e.target.value) {
    setKeyword(e.target.value);
    setPage(1);
    // }
  };

  const handleViewCvtheque = () => {
    push(ROUTES_PATH.CVTHEQUE_SCHOOL, { params: { id: idUser } });
  };

  useEffect(() => {
    handleFormationsLength(totalElements);
  }, [totalElements]);

  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        rowGap: 20,
        height: '100%',
      }}
    >
      <div
        className={css({
          display: 'flex',
          flexWrap: 'wrap',
          gap: spacing(2), // espace entre éléments
          // padding: '0 20px',
          '@media (max-width: 768px)': {
            flexDirection: 'column', // disposition colonne pour petits écrans
          },
        })}
      >
        <div className={classes.selectInput}>
          <TextField
            fullWidth
            id="outlined-basic"
            label={intl.formatMessage({
              id: 'school.formationsCandidats.searchFormation',
            })}
            onChange={(e) => searchFormation(e)}
            size="small"
            variant="outlined"
            borderRadius={30}
            endAdornment={<Search style={{ color: '#5D75A8' }} />}
          />
        </div>

        <div className={classes.selectInput}>
          <TextField
            fullWidth
            label="Domaine d'étude "
            name="domains"
            onChange={(e) => searchTrainingDomains(e)}
            select
            borderRadius={30}
          >
            <MenuItem value="all">Tous les domaines</MenuItem>
            {trainingDomains.map(({ id, label }, index) => (
              <MenuItem key={index} value={id}>
                {label}
              </MenuItem>
            ))}
          </TextField>
        </div>

        <div className={classes.selectInput}>
          <TextField
            fullWidth
            label="Niveau de diplôme"
            name="degree"
            onChange={(e) => searchDegree(e)}
            select
            borderRadius={30}
          >
            <MenuItem value="all">Tous les niveaux</MenuItem>
            {degrees.map(({ id, label }, index) => (
              <MenuItem key={index} value={id}>
                {label}
              </MenuItem>
            ))}
          </TextField>
        </div>

        <div className={classes.selectInput}>
          <TextField
            fullWidth
            label="Type de formation"
            name="trainingType"
            onChange={(e) => searchTrainingType(e)}
            select
            borderRadius={30}
          >
            <MenuItem value="all">Tous les types de formation</MenuItem>
            {trainingTypes.map(({ id, label }, index) => (
              <MenuItem key={index} value={id}>
                {label}
              </MenuItem>
            ))}
          </TextField>
        </div>

        <div
          className={cx(css({
            display: totalElements > 0 ? 'block' : 'none'
          }), classes.selectInput)}
        >
          <Button
            color="primary"
            onClick={handleOpenCreateFormation}
            variant="contained"
            className={classes.btn}
          >
            <FormattedMessage id="school.formationsCandidats.btnPublierFormation" />
          </Button>
        </div>

        <Modal
          nbStep={5}
          onCancel={handleCloseCreateFormation}
          open={openCreateFormation}
          step={stepModal}
          title={intl.formatMessage({
            id: 'school.formationsCandidats.publierFormation',
          })}
        >
          <div style={{ marginBottom: spacing(3) }} className={global.infoText}>
            <div className={css({ display: 'flex', flexDirection: 'row' })}>
              <span>
                <Information className={cx(global.infoIcon, css({ color: '#0060F9' }))} />
              </span>
              Permettez aux candidats retrouver votre offre dans "Postuler" et d'y
              candidater en un seul clic.
              <br /> Publier une formation vous permets également de la lier à une
              classe pour obtenir plus de fonctionnalités.
              <br /> Pour en savoir plus, veuillez lire la Base de connaissance.
            </div>
          </div>
          <CreateFormation
            onChangeStepModal={setStepModal}
            onClose={handleCloseCreateFormation}
            refetchFormation={refetch}
          />
        </Modal>
      </div>

      <div className={classes.formations}>
        <Grid
          className={css({
            '@media only screen and (max-width: 1023px)': {
              maxHeight: '100%',
            },
            overflow: 'auto',
            height: '100%'
          })}
        >
          {
            isLoadingFormations ? (
              <Grid
                container
                className={css({
                  padding: spacing(0, 0, 2.5, 2.5),
                  backgroundColor: '#F3F7FF',
                  borderRadius: 10,
                })}
              >
                {
                  [...Array(size/2)].map((_, index) => (
                    <CardFormation key={index} isLoading={true} />
                  ))
                }
              </Grid>
            ) : formations?.length > 0 ? (
              <Grid
                container
                className={css({
                  padding: spacing(0, 0, 2.5, 2.5),
                  backgroundColor: '#F3F7FF',
                  borderRadius: 10,
                })}
              >
                {formations?.map((item, index) => (
                  <CardFormation
                    key={index}
                    address={item?.address}
                    contrat={item?.trainingType}
                    item={item}
                    idTraining={item?.id}
                    name={item?.label}
                    refetchAllFormation={refetch}
                    typeFormation={item?.degree}
                  />
                ))}
              </Grid>
            ) : (
              <Grid item xs={12} className={classes.noDataContainer}>
                <Nodata
                  image={TrainingsWithSheets}
                  contentWidth='70%'
                  padding='0px 20px 20px 0px'
                  title="Aucune formation trouvée"
                  description="Modifiez vos filtres ou créez votre première formation pour la rendre visible auprès des candidats."
                />
              </Grid>
            )
          }
        </Grid>
      </div>
      {formations?.length > 0 && totalElements > size && (
        <div className={classes.pagination}>
          <PaginationNumbers
            onChange={(newPage) => handlePaginationChange(newPage)}
            page={page}
            pageCount={size}
            totalCount={totalElements}
          />
        </div>
      )}
    </div>
  );
};

const styles = ({ spacing }) => ({
  formations: { flex: 1 },
  btn: {
    width: '100%',
  },
  stepStyles: {
    margin: '10px 0 0 0',
  },
  formations: { flex: 1 },
  infoCandidat: { display: 'flex' },
  tableHead: {
    '&.MuiTableCell-head': {
      color: 'white',
    },
  },
  selectInput: {
    width: '200px',
  },
  noDataContainer: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    backgroundColor: '#F3F7FF',
    borderRadius: 12,
    height: 'calc(100vh - 75px - 193px)',
    '@media only screen and (max-width:1279px)': {
      height: 'calc(100vh - 75px - 243px)',
    },
    '@media screen and (max-width: 768px)': {
      padding: '20px',
    },
  },
  pagination: {
    display: 'flex',
    justifyContent: 'center',
    marginTop: spacing(2),
  },
});

export default Formations;
